import * as BABYLON from "babylonjs";
import { EventBus } from "./EventBus";
import config from "./config";
export class Camera  extends BABYLON.ArcRotateCamera{
  constructor(scene, dom) {
    super(
        "ArcRotateCamera",
        Math.PI / 2,
        Math.PI / 2.3,
        15,
        new BABYLON.Vector3(0, 0, 0),
        scene
      )
    this.cameraInit(dom)
    this.eventBus = new EventBus()
    this.cameraAnimate = false;
    this.eventBus.$on('cameraGoOver', () => {
      // console.log('cameraGoOver');
        this.cameraAnimate.stop();
        this.cameraAnimate = false;
      });

  }
  cameraInit(scene, dom){
      this.useBouncingBehavior = !0;
      this.angularSensibilityX = 1e3;
      this.angularSensibilityY = 1e3;
      this.lowerRadiusLimit = 5;
      this.upperRadiusLimit = 50;
      this.lowerBetaLimit = Math.PI / 6;
      // this.upperBetaLimit = Math.PI / 2.4;
      this.upperBetaLimit = Math.PI / 2.1;
      this.paddingDistanceLimit = 0.01;
      this.panningAxis = new BABYLON.Vector3(1,0,0)
      this.minZ = 0
      this.maxZ = 1050;
      this.attachControl(dom, !0, 0);
  }
  setlevel(level){
    // if(level === 0|| level === 1){
    //   this.minZ = 1
    //   this.maxZ = 1050;
    // }



    // if(level === 2 || level === 4){
    //   this.minZ = 1
    //   this.maxZ = 100;
    // }

  }
  getdistence(poi,lookat){
    let x = Math.abs(poi[0]-lookat[0])
    let y = Math.abs(poi[1]-lookat[1])
    let z = Math.abs(poi[2]-lookat[2])
    return Math.pow((x*x+y*y+z*z),0.5)
  }
  cameraGo(poi,lookat, duration) {
    // console.log(poi,lookat);
    this.lowerRadiusLimit = 0;
    this.upperRadiusLimit = 5000;
    if (this.cameraAnimate) {
      this.cameraAnimate.stop();
      // console.log('this.cameraAnimate.stop');
    }
    let distence = this.getdistence(poi,lookat)
    var target1 = new BABYLON.Vector3(...poi);
    var target2 = new BABYLON.Vector3(...lookat);
    let animation1 = new BABYLON.Animation(
      'positionAnimation',
      "position",
      60 *1000 / duration  ,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANAMATIONLOOPMODE_CONSTANT
    );
    let animation2 = new BABYLON.Animation(
      'targetAnimation',
      "target",
      60 *1000 / duration  ,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
    );
    var keys1 = [
      {
        frame: 0,
        value: this.position,
      },
      {
        frame: 60 ,
        value: target1
      }
    ];

    var keys2 = [
      {
        frame: 0,
        value: this.target,
      },
      {
        frame: 20 ,
        value: target2
      },
      {
        frame: 60 ,
        value: target2
      },
    ];
    animation1.setKeys(keys1);
    animation2.setKeys(keys2);
    //创建一个 easing function
    // var easingFunction = new BABYLON.CircleEase();
    // 对于 easing function, 你可以设置 EASEIN (default), EASEOUT, EASEINOUT
    // easingFunction.setEasingMode(BABYLON.EasingFunction.EASEOUT);
    // animation2.setEasingFunction(easingFunction);
    this.cameraAnimate = new BABYLON.AnimationGroup();
    this.cameraAnimate.addTargetedAnimation(animation1, this);
    this.cameraAnimate.addTargetedAnimation(animation2, this);

    this.cameraAnimate.normalize(0, 60);
    this.cameraAnimate.play(true);
    let that = this
    setTimeout(()=>{that.cameraAnimateStop(distence);},duration+100)
    this.cameraAnimate.onAnimationEndObservable.add(function () {
        // console.log('cameraAnimateStop');
        that.cameraAnimateStop(distence);
    });
  }

  cameraGoMesh(mesh){
     let position = mesh.absolutePosition
     let rotation = mesh.$objinfo.meta.rotation
      let r = mesh.getBoundingInfo().boundingSphere.radius * mesh.scaling.x * 4
      let poi = [position._x ,(position._y + r)/4,position._z + r]
      if(rotation==90){
        poi = [position._x+ r ,(position._y + r)/4,position._z ]
      }
      if(rotation==180){
        poi = [position._x ,(position._y + r)/4,position._z - r]
      }
      if(rotation==270){
        poi = [position._x- r ,(position._y + r)/4,position._z]
      }
      let target = [position._x,position._y,position._z]
      if (mesh.$type) {
        let y = config[mesh.$type].height/2 + config.table.height
        // poi[0] = position._x
        poi[1] = y
        target[1] = y
      }
      levelsShowIns.poplabel();
      levelsShowIns.camera.cameraGo(poi,target,500)
      return new Promise(reolve=>{
        setTimeout(reolve,500)
      })
  }
  cameraAnimateStop(distence){
    this.lowerRadiusLimit = distence / 5;
    this.upperRadiusLimit = distence * 5;
    this.eventBus.$emit('cameraGoOver')
  }
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Camera.js